import { OneTimePurchaseBookingStatus } from '@platform-frontend/checkout-drop-in';
import { AssetEssentials } from './asset-essentials';
import { SerializedOneTimePurchaseDetails } from './serialized-one-time-purchase-details';

export interface SerializedOneTimePurchase<T = OneTimePurchaseBookingStatus> extends AssetEssentials<string> {
  type: 'ONE_TIME_PURCHASE';
  oneTimePurchaseDetails: SerializedOneTimePurchaseDetails<T>;
}
